import { Flex } from '@chakra-ui/react';
import { usePostHog } from 'posthog-js/react';
import { InlineWidget, useCalendlyEventListener } from 'react-calendly';

export type UTMParams = {
  utmCampaign?: string;
  utmContent?: string;
  utmMedium?: string;
  utmSource?: string;
  utmTerm?: string;
};

export type CalendlyProps = {
  eventSlug?: string;
  prefill?: any;
  userData?: any;
  utmParams: UTMParams;
  isOpen?: boolean;
  setIsOpen?: (value: boolean) => void;
  onClose?: () => void;
};

const Calendly = ({ userData, eventSlug, utmParams, prefill }: CalendlyProps) => {
  const posthog = usePostHog();

  useCalendlyEventListener({
    onProfilePageViewed: () => posthog.capture('Calendly Profile Viewed'),
    onDateAndTimeSelected: () => posthog.capture('Calendly Date And Time Selected'),
    onEventTypeViewed: () => {
      posthog.capture('Calendly Event Type Viewed');
    },
    onEventScheduled: (event) => {
      posthog.capture('Calendly Event Scheduled', { event });
    },
  });

  if (userData?.utm_source) {
    utmParams.utmSource = userData?.utm_source;
  }

  return (
    <Flex
      height={['1200px', '1100px', '1100px', '900px']}
      alignItems="center"
      justifyContent="center"
      w="100%"
      mb={['100px']}
    >
      <InlineWidget
        styles={{ height: '100%', width: '100%', display: 'block' }}
        url={`https://calendly.com/${eventSlug}`}
        utm={utmParams}
        prefill={prefill}
        pageSettings={{
          hideGdprBanner: true,
        }}
      />
    </Flex>
  );
};

Calendly.defaultProps = {
  eventSlug: 'fair-square-medicare/talk-to-an-expert',
  prefill: {},
  userData: null,
};

export default Calendly;
